module.exports = __webpack_public_path__ + "img/2.871e4c82.jpg";